import { Injectable } from '@angular/core';
import { RuntimeConfig } from '@app/runtime-config';
import { LogEventType, LogException, LogHandler, LogPayload } from '@app/shared/logging/abstract';
import { LogService } from '@app/shared/logging/log.service';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ConsoleLogService {

	constructor (
		private logService: LogService,
		private runtimeConfig: RuntimeConfig
	) { }

	init (): void {
		if (this.runtimeConfig.appSettings.logging.console.enabled) {
			this.setupListeners();
		}
	}

	private setupListeners (): void {
		const handlers = this.getSupportedHandlers();
		const observable = this.logService.getObservable();
		for (let handler of handlers) {
			observable
				.pipe(filter(f => f.eventType == handler.eventType))
				.subscribe(payload => handler.handler(payload.payload));
		}
	}

	private getSupportedHandlers (): LogHandler[] {
		const handlers: LogHandler[] = [
			{
				eventType: LogEventType.Information,
				handler: this.information
			},
			{
				eventType: LogEventType.Warning,
				handler: this.warning
			},
			{
				eventType: LogEventType.Debug,
				handler: this.debug
			},
			{
				eventType: LogEventType.Error,
				handler: this.error
			},
			{
				eventType: LogEventType.Fatal,
				handler: this.fatal
			}
		];

		return handlers;
	}

	private information (payload: LogPayload): void {
		console.info(payload);
	}

	private warning (payload: LogPayload): void {
		console.warn(payload);
	}

	private debug (payload: LogPayload): void {
		console.debug(payload);
	}

	private error (payload: LogException): void {
		console.error(payload);
	}

	private fatal (payload: LogException): void {
		console.error('Fatal: %o', payload);
	}
}